import { Form } from "antd";
import React from "react";
import Utils from "utils";
import { formatMoney, formatterNumber } from "utils/helper";

const MediEditColumnTableCell = ({
  required = false,
  editing = true,
  children,
  value,
  typeField,
  containerStyle,
  valuePropName = "value",
  customValue = null,
  shouldUpdate = null,
  ...rest
}) => {
  const formatValue =
    typeField === "money"
      ? `${formatMoney(value)}`
      : typeField === "number"
      ? `${formatterNumber(value)}`
      : typeField === "datetime"
      ? Utils.formatDate(value)
      : typeField === "date"
      ? Utils.formatDate(value, true)
      : value;

  const shouldUpdatedFormItem = (
    <Form.Item noStyle shouldUpdate={shouldUpdate}>
      {children}
    </Form.Item>
  );

  return editing ? (
    shouldUpdate ? (
      shouldUpdatedFormItem
    ) : (
      <Form.Item
        rules={[
          {
            required: required,
            message: "Bắt buộc!",
          },
        ]}
        valuePropName={valuePropName}
        {...rest}
      >
        {children}
      </Form.Item>
    )
  ) : customValue ? (
    customValue(value)
  ) : (
    value && <span style={containerStyle}>{formatValue}</span>
  );
};

export default MediEditColumnTableCell;
